import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FiCheckCircle, FiXCircle, FiTrash2 } from "react-icons/fi";
import api from "api";
import { debug } from "utils";
const REJECT_REASONS = [
  { code: "unreadable", label: "Document illisible ou mal cadré" },
  { code: "expired", label: "Document expiré" },
  { code: "incomplete", label: "Document incomplet" },
  { code: "wrong_document", label: "Document non conforme / incorrect" },
  { code: "other", label: "Autre (précisez)" },
];
export default function QualityFileModal({
  show,
  onClose,
  file,
  fileAnalysis,
  onAccept,
  onReject,
  requestId,
  onDelete = null,
  readOnly
}) {
  const [rejectReason, setRejectReason] = useState("");
  const [rejectComment, setRejectComment] = useState("");
  const [blobUrl, setBlobUrl] = useState(null);
  useEffect(() => {
    let objectUrl;

    const load = async () => {
      const parts = file.path.split("/").filter(Boolean);
      const basename = parts.at(-1);
      const requestsIndex = parts.indexOf("requests");

      const url = `/admin/formalities/request/${requestId}/document/open`
      const res = await api.get(
        url,
        {
          params: { src: basename },
          responseType: "blob"
        }
      );
      objectUrl = URL.createObjectURL(res.data);
      setBlobUrl(objectUrl);
    };

    load();

    return () => {
      if (objectUrl) {
        // URL.revokeObjectURL(objectUrl);
      }
    };
  }, [file.path]);
  const status = fileAnalysis?.status || null;
  const isImage = ["jpg", "jpeg", "png", "gif", "webp", "bmp"].includes(
    file.ext.toLowerCase()
  );
  const isPdf = file.ext.toLowerCase() === "pdf";
  // Pré-remplissage si déjà analysé
  useEffect(() => {
    if (fileAnalysis?.status === "rejected") {
      // Sans code backend fiable → fallback sur "other"
      setRejectReason(fileAnalysis.code || "other");
      setRejectComment(fileAnalysis.comment || "");
    } else {
      setRejectReason("");
      setRejectComment("");
    }
  }, [fileAnalysis]);
  const handleRejectFile = () => {

    onReject(file, {
      code: rejectReason,
      comment: rejectReason === 'other' ? rejectComment : REJECT_REASONS.find((r) => r.code === rejectReason)?.label,
    })
  }
  if (!file) return null;
  return (
    <Modal show={show} onHide={onClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center gap-2">
          {file.name}
          {status === "accepted" && (
            <FiCheckCircle className="text-success" />
          )}
          {status === "rejected" && (
            <FiXCircle className="text-danger" />
          )}
        </Modal.Title>
      </Modal.Header>
      <div className="p-0 d-flex" style={{ minHeight: "80vh" }}>
        {/* VIEWER */}
        <div className="flex-grow-1 bg-light d-flex align-items-center justify-content-center p-3">
          {isImage && false && (
            <img
              key={blobUrl}
              src={blobUrl}
              alt={file.name}
              className="img-fluid rounded"
              style={{ maxHeight: "75vh" }}
            />
          )}
          {blobUrl && isPdf && true && (
            <iframe
              key={blobUrl}
              src={blobUrl}
              title={file.name}
              className="border rounded"
              style={{ width: "100%", height: "75vh" }}
            />
          )}

        </div>
        {/* ACTIONS */}
        {readOnly === false &&
          <div
            className="d-flex flex-column justify-content-start p-4 border-start  text-center"
            style={{ width: "220px" }}
          >
            <div className="">
              <div className="fs-6 mb-2 small">Document valide :</div>
              {/* ACCEPTER */}
              <button
                className="btn btn-light  w-100"
                disabled={readOnly || status === "accepted"}
                onClick={() => onAccept(file)}
                title="Accepter le document"
              >
                <FiCheckCircle size={36} className="text-success" />
              </button>
            </div>
            <div style={{ borderTop: "1px solid var(--bs-dark)", opacity: 0.5 }} className="w-100 my-4" />
            <div className="mb-4">
              <div className="fs-6 mb-2 small">Document invalide :</div>
              {/* REJET */}
              <div className="w-100">
                <select
                  className="form-select form-select-sm mb-2"
                  value={rejectReason}
                  disabled={readOnly}
                  onChange={(e) => setRejectReason(e.target.value)}
                >
                  <option value="">Motif de rejet…</option>
                  {REJECT_REASONS.map((r) => (
                    <option key={r.code} value={r.code}>
                      {r.label}
                    </option>
                  ))}
                </select>
                {rejectReason === "other" && (
                  <textarea
                    className="form-control form-control-sm mb-2"
                    placeholder="Précisez la raison…"
                    value={rejectComment}
                    disabled={readOnly}
                    onChange={(e) => setRejectComment(e.target.value)}
                    rows={3}
                  />
                )}
                <button
                  className="btn btn-light w-100"
                  disabled={
                    readOnly ||
                    !rejectReason ||
                    (rejectReason === "other" && !rejectComment.trim())
                  }
                  onClick={handleRejectFile}
                  title="Refuser le document"
                >
                  <FiXCircle size={32} className="text-danger" />
                </button>
              </div>
            </div>
            {(onDelete) && <div>
              <div style={{ borderTop: "1px solid var(--bs-dark)", opacity: 0.5 }} className="w-100 my-4" />
              <div className="fs-6 mb-2 small">Supprimer le document&nbsp;:</div>
              <button
                className="btn btn-light  w-100"
                onClick={onDelete}
                title="Supprimer le document"
              >
                <FiTrash2 size={32} className="text-dark" />
              </button>
            </div>
            }
          </div>}
      </div>
    </Modal>
  );
}
